<template>
	<div id="login-body">
		<div id="login">
			<el-row>
			    <el-col :span="12">
					<img :src="img|Ximgurl" class="loginImg" />
			    </el-col>
			    <el-col :span="12" style="background-color: #FFFFFF;">
					
				    <div class="loginrightBcg">
						<div class="loginrightBcg-header"></div>
						<div class="loginrightBcg-tab">
							<div class="activt">密码登录</div>
							<!-- <div @click="tabClick(1)" :class="activtType==1?'activt':''">验证码登录</div> -->
						</div>
						<div class="loginrightBcg-input" v-if="activtType==0">
							<el-input
							  placeholder="手机号码/账号"
							  v-model="keyword"
							  clearable>
							</el-input>
							<el-input placeholder="请输入密码" v-model="password" show-password></el-input>
						</div>
						
						<div class="loginrightBcg-input" v-if="activtType==1">
							<el-input
							  placeholder="手机号码"
							  v-model="keyword"
							  clearable>
							</el-input>
							
							<div class="loginrightBcg-input-div">
								<el-input placeholder="验证码" v-model="code" ></el-input> 
								<el-button round size="mini" v-show="show" @click="getCode">获取验证码</el-button>
								<el-button round size="mini"  v-show="!show">{{count}} s</el-button>
							</div>
							
						</div>
						<!-- <router-link to="/forgetpassword"><div  style="color: rgba(217, 0, 27, 1); text-align: right; width: 92%;font-size: 12px;padding-top: 10px;">忘记密码？</div></router-link> -->
						
						<el-button @click="loginClick()" class="button1" type="danger" size="medium " round>登录</el-button>
						
						<div class="loginrightBcg-top">
							<span >没有账号？</span>
							<router-link to="/register">
							<span style="color: rgba(217, 0, 27, 1);">立即注册</span>
							</router-link>
						</div>
				    </div>
					
			    </el-col>
			</el-row>
		</div>
	</div>
	
</template>

<script>
	 export default {
	    data() {
	      return {
	        keyword: '',
			password : '',
			activtType:0,
			code : '',
			show: true,
			count: '',
			img  : '',
	      }
	    },
		created() {
			let that = this;
			that.$http('get','/api/v1/config?name=login',{}) .then(function (res) {
				that.img = res.data; 
				console.log(res);
			});
			if(localStorage.token && that.$route.path=='/'){
				that.$router.push('/index');	 
			}
		},
		methods:{
			tabClick(e){
				let that = this;
				that.activtType = e;
			},
			message(msg,type){
				this.$message({
				    message: msg,
					showClose: true,
				    type: type
				});
				
			},
			loginClick(){
					let that = this;
					if(!that.keyword){
						that.message('手机号码/账号不得为空','error');return;
					}
					if(that.activtType==0){
						if(!that.password){
							that.message('密码不得为空','error');return;
						}
						that.$http('post','/api/v1/userlogin/login',{'mobile':that.keyword,'password':that.password}) .then(function (response) {
							if(response.code==200){
								localStorage.setItem('token',response.data);
								that.message(response.msg,'success');
								 that.$router.push('/index');
								return;
							}else{
								
								that.message(response.msg,'error');return;
							}
							console.log(response);
						});
					}else{
						if(!that.code){
							that.message('验证码不得为空','error');return;
						}
						that.$http('post','/api/login/loginSms',{'phone':that.keyword,'code':that.code}) .then(function (response) {
							if(response.code==1){
								localStorage.setItem('token',response.data);
								that.message(response.msg,'success');
								 that.$router.push('./../Common');
								return;
							}else{
								that.message(response.msg,'error');return;
							}
							console.log(response);
						});
					}
					
					
				console.log(2);
				//
			},
			 getCode(){
			     const TIME_COUNT = 60;
				 let that = this;
				 if(!that.keyword){
				 	that.message('手机号码/账号不得为空','error');return;
				 }
				 that.$http('post','/api/login/sms',{'phone':that.keyword}) .then(function (response) {
				 	if(response.code==1){
						 const TIME_COUNT = 60;
				 		if (!that.timer) {
				 		  that.count = TIME_COUNT;
				 		  that.show = false;
				 		  that.timer = setInterval(() => {
				 		  if (that.count > 0 && that.count <= TIME_COUNT) {
				 		    that.count--;
				 		   } else {
				 		    that.show = true;
				 		    that.timer = null;
				 		   }
				 		  }, 1000)
				 		 }
				 	}
				 });
			     
			}  
		}
	  }
</script>

<style >
	.el-col-12 {
		width: auto;
	}
	#login-body {
		background-color: rgba(245, 245, 250, 1);
		min-width: 900px;
		min-height: 100vh;
	
	}
	#login {
	  font-family: 'Avenir', Helvetica, Arial, sans-serif;
	  -webkit-font-smoothing: antialiased;
	  -moz-osx-font-smoothing: grayscale;
	  text-align: center;
	  color: #2c3e50;
	  /* width: 70%; */
	  width: 900px;
	  margin-left: auto;
	  margin-right: auto;
	  padding-top: 60px;
	}
	.loginImg {
		/* width: 100%; */
		width: 460px;
		height: 500px;
		
	}
	.loginrightBcg {
		width: 80%;
		height: 500px;
		margin-left: auto;
		margin-right: auto;
	}
	.loginrightBcg-header {
		height: 80px;
	}
	.loginrightBcg-tab {
		height: 100px;
		display: flex;
		text-align: center;
		justify-content: center;
		color: #2c3e50a3;
	}
	.loginrightBcg-tab div {
		padding-left: 10px;
		padding-right: 10px;
		
	}
	.loginrightBcg-input input {
		display: block;
		margin-left: auto;
		margin-right: auto;
		border: none;
		height: 40px;
		width: 80%;
		border-radius: 0;
		border-bottom: 1px solid rgb(205 205 208);
		margin-top: 20px;
	}
	.loginrightBcg-input-div {
		width: 80%;
		margin-left: auto;
		margin-right: auto;
		display: flex;
		height: 45px;
		border-bottom: 1px solid rgb(205 205 208);
		margin-top: 20px;
	}
	.loginrightBcg-input-div input {
		border: none;
		width: auto;
		flex: 2;
		margin-left: 0px;
		margin-top: 0;
	}
	.loginrightBcg-input-div button {
		margin-top: 5px;
		height: 34px;
	}
	.button1 {
		height: 40px;
		width: 180px;
		margin-top: 40px !important;
		background-color: rgba(217, 0, 27, 1) !important;
	}
	.loginrightBcg-top {
		padding-top: 20px;
		color: #2c3e50a3;
		
	}

	.activt {
		 color: #2c3e50;
	}
	.activt:after{ content:""; width:2rem; height:2px; background-color: red; margin:0 auto 0 auto; display:block; margin-top: 3px; }

	 .el-row {
	    margin-bottom: 20px;
	    &:last-child {
	      margin-bottom: 0;
	    }
	  }
	  .el-col {
	    border-radius: 4px;
	  }
	  .bg-purple-dark {
	    background: #99a9bf;
	  }
	  .bg-purple {
	    background: #d3dce6;
	  }
	  .bg-purple-light {
	    background: #e5e9f2;
	  }
	  .grid-content {
	    border-radius: 4px;
	    min-height: 36px;
	  }
	  .row-bg {
	    padding: 10px 0;
	    background-color: #f9fafc;
	  }
</style>
